export default __webpack_public_path__ + "static/media/hooks.a69b80bc.jpg";